'use client'

import { Box, Stack, styled, Typography } from '@mui/material'

import { Link } from '@/components/ContentStack/Link'
import { useMedia } from '@/hooks/useMedia'

import type { FC } from 'react'
import type { SanityHeader } from '@/interfaces/SanityHeader'

export const USPBarWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
}))

interface USPBarProps {
  usps?: SanityHeader['uspBanner']
}

export const USPBar: FC<USPBarProps> = ({ usps }) => {
  const { isMobile } = useMedia()

  return (
    <USPBarWrapper
      sx={{
        paddingBlock: 1.5,
        height: '100%',
      }}
    >
      <Stack
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="flex-end"
        columnGap={2}
        rowGap={1}
        color="secondary"
      >
        {usps &&
          usps.slice(0, isMobile ? 1 : usps.length).map((usp) => (
            <Typography
              variant="body2"
              key={usp._id}
              sx={(theme) => ({
                color: theme.palette.text.secondary,
                whiteSpace: 'nowrap',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              })}
            >
              <Link {...usp} linkProps={{ color: 'inherit' }} />
            </Typography>
          ))}
      </Stack>
    </USPBarWrapper>
  )
}
